/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { availableProjectRegions, PRODUCT_NAME } from 'config';
import intl from 'utils/global-intl-provider';

export const REGION_US = 'US';
export const REGION_US_CDP_2 = 'US_CDP_2';
export const REGION_EU = 'EU';
export const REGION_IND = 'IND';
export const DEFAULT_DP_REGION = availableProjectRegions[0];

export const labelEU = intl.formatMessage({
  id: 'createProject.projectRegionInput.labelEU',
  defaultMessage: 'EU',
});
export const labelUS = intl.formatMessage({
  id: 'createProject.projectRegionInput.labelUS',
  defaultMessage: 'US',
});
export const labelIND = intl.formatMessage({
  id: 'createProject.projectRegionInput.labelIND',
  defaultMessage: 'IND',
});

export const defaultProjectName = intl.formatMessage({
  id: 'createProject.projectNameInput.defaultProjectName',
  defaultMessage: 'Default',
});

export const defaultProjectHandler = intl.formatMessage({
  id: 'createProject.projectHandlerInput.defaultProjectHandler',
  defaultMessage: 'default',
});

export const defaultProjectDescription = intl.formatMessage(
  {
    id: 'createProject.projectDescriptionInput.defaultProjectDescription',
    defaultMessage: 'This is a default project created by the {productName}',
  },
  { productName: PRODUCT_NAME }
);

export const regionLabels: Record<string, string> = {
  [REGION_US]: labelUS,
  [REGION_EU]: labelEU,
  [REGION_IND]: labelIND,
};
